module.exports = __webpack_public_path__ + "img/erro-404.2affb588.png";